export default {
  version: '2.16.2',
  pageSize: 10,
};
